module.exports = __webpack_public_path__ + "img/ronghe_right.bdc14e91.jpg";